export const FILL_PROTOCOL = 'FILL_PROTOCOL'
export const FILL_HISTORY = 'FILL_HISTORY'
export const FILL_PROTOCOL_ITEMS_DATA = 'FILL_PROTOCOL_ITEMS_DATA'
export const FILL_TIMELINE = 'FILL_TIMELINE'